import { ReactElement, useCallback } from 'react';
import moment from 'moment-timezone';

import { PlanFeaturesTypes } from '~globals/types/enums';
import { useDownloadReportItemTasks } from '~hooks/useReports';
import { formatterDate } from '~utils/formatter';

import ReportsDownloadSectionWrapperSectionItem from '../../../../Wrappers/SectionItem';
import ReportsDownloadSectionWrapperForm from '../../../../Wrappers/Form';
import { ReportsDownloadSectionWrapperFormSubmitHandler } from '../../../../Wrappers/Form/types';

const ReportsDownloadSectionVariantBySectionItemTasks = (): ReactElement => {
  const { loading, error, onDownload } = useDownloadReportItemTasks();

  const onSubmit = useCallback<ReportsDownloadSectionWrapperFormSubmitHandler>(
    async (formValues) => {
      await onDownload({
        dateTimeFrom: formatterDate(formValues.dateFrom, {
          format: moment.HTML5_FMT.DATETIME_LOCAL_MS,
          parseToUtc: true,
        }),
        dateTimeTo: formatterDate(formValues.dateTo, {
          format: moment.HTML5_FMT.DATETIME_LOCAL_MS,
          parseToUtc: true,
        }),
        emailDestinatary: '',
      });
    },
    [onDownload],
  );

  return (
    <ReportsDownloadSectionWrapperSectionItem
      title="Reporte de artículos / tareas"
      validSubscriptionFeature={{
        validFeature: PlanFeaturesTypes.MgmItemTask,
      }}
    >
      <ReportsDownloadSectionWrapperForm
        onSubmit={onSubmit}
        loadingSubmit={loading}
        errorSubmit={Boolean(error)}
        withSelectorType={false}
        gutters
      />
    </ReportsDownloadSectionWrapperSectionItem>
  );
};

export default ReportsDownloadSectionVariantBySectionItemTasks;
